import { Entity } from '@app/core/model/entities/entity';

export class CartovistaParameters extends Entity {
  public serverUrl: string;
  public tenantCode: string;
  public mapUrl: string;
  public apiKey?: string;
  public areApiKeysSet: boolean;

  public toString(): string {
    return this.serverUrl;
  }
}
